import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip, Box } from '@material-ui/core'

import { ReactComponent as DraftImage } from '@assets/images/system-icons/draft.svg'
import { ReactComponent as ReviewImage } from '@assets/images/system-icons/progress.svg'

import { TimeValuePropType } from '@hooks/useTimeValue'
import { TimeValueToggle } from '@components/TimeValueToggle'
import ContentEditable from '@components/ContentEditable'

export const ScenarioHeader = (props) => {
  const { scenario } = props
  const scenarioImplementedOrHistoric = scenario.planType === 'implemented' || scenario.planType === 'historic'

  return (
    <section className='scenario-header header flex px-4 pt-4'>
      <div className='scenario-header__details flex-row items-center'>
        {!scenarioImplementedOrHistoric &&
          <PlanTypeIndicator status={scenario.status} planType={scenario.planType} />
        }
        <div className='scenario-details__plan-name'>
          <h1>
            <label>{props.label}</label>
            {!scenarioImplementedOrHistoric &&
              <ScenarioNameContentEditable
                updateScenario={props.updateScenario}
                scenarioName={scenario.name} />}
            {scenarioImplementedOrHistoric && getScenarioName(scenario.planType, scenario.name)}
          </h1>
        </div>
      </div>
      {props.timeValue && props.setTimeValue
        ?
        <div className='hidden sm:block'>
          <TimeValueToggle
            setTimeValue={props.setTimeValue}
            timeValue={props.timeValue}
          />
        </div>
        : null
      }
    </section>
  )
}

const ScenarioNameContentEditable = ({ scenarioName, updateScenario }) => {
  const defaultName = 'My plan'
  const scenarioNameRef = React.createRef()
  const [name, setName] = React.useState(scenarioName)
  const onBlurHandler = () => {
    if (name === '') {
      setName(defaultName)
      updateScenario({ name: defaultName })
    } else {
      updateScenario({ name })
    }
  }
  const onChangeHandler = (value) => setName(value)
  const onKeyDownHandler = (event) => {
    if (event.keyCode === 13 || event.key === 'Enter') {
      scenarioNameRef.current.blur()
    }
  }

  return (
    <Tooltip title="Click to edit the scenario's name" placement='bottom'>
      <Box>
        <ContentEditable
          innerRef={scenarioNameRef}
          tagName='span'
          placeholder={defaultName}
          html={name}
          onBlur={onBlurHandler}
          onChange={onChangeHandler}
          onKeyDown={onKeyDownHandler} />
      </Box>
    </Tooltip>
  )
}

const PlanTypeIndicator = (props) => {
  const image = statusImage(props)
  const text = statusText(props)

  return (
    <div className='scenario-details__plan-type !hidden md:!flex'>
      {image}
      <p>{text}</p>
    </div>
  )
}

const statusImage = (props) => {
  const { status, planType } = props

  if (planType == 'scenario' && status == 'draft') {
    return <DraftImage />
  } else if (planType == 'scenario' && status == 'in_review') {
    return <ReviewImage />
  } else {
    return <DraftImage />
  }
}

const statusText = (props) => {
  const { status, planType } = props

  if (planType == 'scenario' && status == 'draft') {
    return "Draft"
  } else if (planType == 'scenario' && status == 'in_review') {
    return "In Review"
  } else {
    return "Draft"
  }
}

const getScenarioName = (planType, name) => {
  if (planType === 'historic') {
    return `${name} (Historic)`
  } else {
    return name
  }
}

ScenarioHeader.propTypes = {
  scenario: PropTypes.shape({
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    planType: PropTypes.string.isRequired,
  }).isRequired,
  label: PropTypes.string.isRequired,
  updateScenario: PropTypes.func.isRequired,
  timeValue: TimeValuePropType.isRequired,
  setTimeValue: PropTypes.func.isRequired
}
